var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "omegaup-histogram-container" }, [
    _c("p", { staticClass: "omegaup-histogram-title" }, [
      _vm._v(_vm._s(_vm.title)),
    ]),
    _c("div", { staticClass: "omegaup-histogram" }, [
      _c("div", { staticClass: "omegaup-histogram-1" }, [
        _c("p", { staticClass: "omegaup-histogram-score" }, [
          _vm._v(_vm._s(_vm.score.toFixed(1))),
        ]),
        _c("p", { staticClass: "omegaup-histogram-votes" }, [
          _vm._v(
            " 👥 " + _vm._s(_vm.totalVotes + " " + _vm.T.wordsTotalVotes) + " "
          ),
        ]),
      ]),
      _c("div", { staticClass: "omegaup-histogram-2" }, [
        _c("div", { staticClass: "omegaup-histogram-item" }, [
          _c("div", { staticClass: "omegaup-histogram-bar-name" }, [
            _vm._v(" " + _vm._s(_vm.tags[0]) + " "),
          ]),
          _c(
            "div",
            {
              staticClass: "omegaup-histogram-bar omegaup-histogram-bar-1",
              style: `width:${_vm.barsWidth[0]}%`,
            },
            [_vm._v(" " + _vm._s(`${_vm.customHistogram[0]}`) + " ")]
          ),
        ]),
        _c("div", { staticClass: "omegaup-histogram-item" }, [
          _c("div", { staticClass: "omegaup-histogram-bar-name" }, [
            _vm._v(" " + _vm._s(_vm.tags[1]) + " "),
          ]),
          _c(
            "div",
            {
              staticClass: "omegaup-histogram-bar omegaup-histogram-bar-2",
              style: `width:${_vm.barsWidth[1]}%`,
            },
            [_vm._v(" " + _vm._s(`${_vm.customHistogram[1]}`) + " ")]
          ),
        ]),
        _c("div", { staticClass: "omegaup-histogram-item" }, [
          _c("div", { staticClass: "omegaup-histogram-bar-name" }, [
            _vm._v(" " + _vm._s(_vm.tags[2]) + " "),
          ]),
          _c(
            "div",
            {
              staticClass: "omegaup-histogram-bar omegaup-histogram-bar-3",
              style: `width:${_vm.barsWidth[2]}%`,
            },
            [_vm._v(" " + _vm._s(`${_vm.customHistogram[2]}`) + " ")]
          ),
        ]),
        _c("div", { staticClass: "omegaup-histogram-item" }, [
          _c("div", { staticClass: "omegaup-histogram-bar-name" }, [
            _vm._v(" " + _vm._s(_vm.tags[3]) + " "),
          ]),
          _c(
            "div",
            {
              staticClass: "omegaup-histogram-bar omegaup-histogram-bar-4",
              style: `width:${_vm.barsWidth[3]}%`,
            },
            [_vm._v(" " + _vm._s(`${_vm.customHistogram[3]}`) + " ")]
          ),
        ]),
        _c("div", { staticClass: "omegaup-histogram-item" }, [
          _c("div", { staticClass: "omegaup-histogram-bar-name" }, [
            _vm._v(" " + _vm._s(_vm.tags[4]) + " "),
          ]),
          _c(
            "div",
            {
              staticClass: "omegaup-histogram-bar omegaup-histogram-bar-5",
              style: `width:${_vm.barsWidth[4]}%`,
            },
            [_vm._v(" " + _vm._s(`${_vm.customHistogram[4]}`) + " ")]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }